import React from "react";
import { Route, Switch, Redirect } from "react-router-dom";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import GridItemLogin from "components/Grid/GridItemLogin.js";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import LoginInput from "components/CustomInput/LoginInput.js";
import PasswordInput from "components/CustomInput/PasswordInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardBody from "components/Card/CardBody.js";
import CardFooter from "components/Card/CardFooter.js";
import Config from "conFig.js";
import Snackbar from "components/Snackbar/Snackbar.js";
import AddAlert from "@material-ui/icons/AddAlert";
import Home from "views/Home/Home.js";
//import Admin from "layouts/Admin.js";
import Background from "assets/img/background_login.png";
import LoadingOverlay from "react-loading-overlay-ts";
import styles from "assets/jss/material-dashboard-react/components/loginInputStyle.js";
const useStyles = makeStyles(styles);

export default function Login() {
  const [token, setToken] = React.useState(localStorage.getItem("token"));
  const classes = useStyles();
  const [username, setUsername] = React.useState(null);
  const [password, setPassword] = React.useState(null);
  const [tokenvalid, setTokenvalid] = React.useState(null);
  const [alert, setAlert] = React.useState(false);
  const [alert2, setAlert2] = React.useState(false);
  const [isActive, setActive] = React.useState(false);
  const handleButtonClicked = () => {
    setActive((value) => !value);
    setTimeout(() => setActive(false), 2000);
  };
  const loaddata = () => {
    handleButtonClicked();
    if (username && password) {
      var url = Config.backend + "/api/users/authenticate";
      fetch(url, {
        method: "POST",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
        },
        body: JSON.stringify({ username: username, password: password }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.token === undefined) {
            showNotification2();
          } else {
            localStorage.setItem("token", data.token);
            localStorage.setItem("role", data.role);
            localStorage.setItem("name", data.firstName);
            localStorage.setItem("username", data.username);
            setToken(data.token);
            luulog();
          }
        })
        .catch((error) => {
          console.error("Error fetching data: ", error);
        });
    } else {
      showNotification();
    }
  };
  const luulog = () => {
    var url = Config.backend + "/api/LoginLog/them_loginlog";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
      },
      body: JSON.stringify({ username: username, ip: 1 }),
    })
      .then((res) => res.json())
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const checktoken = () => {
    var url = Config.backend + "/api/Users/CheckToken";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json, text/plain",
        "Content-Type": "application/json;charset=UTF-8",
        Authorization: "Bearer " + token,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        setTokenvalid(data);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const showNotification = () => {
    setAlert(true);
    setTimeout(function () {
      setAlert(false);
    }, 6000);
  };
  const showNotification2 = () => {
    setAlert2(true);
    setTimeout(function () {
      setAlert2(false);
    }, 6000);
  };
  const setuser = (value) => {
    setUsername(value);
  };
  const setpass = (value) => {
    setPassword(value);
  };
  React.useEffect(() => {
    checktoken();
  }, [token]);
  if (tokenvalid === 1) {
    return (
      <Switch>
        <Redirect from="/admin/login" to="/admin/home" />
        <Route path="/admin" component={Home} />
      </Switch>
    );
  }
  return (
    <div
      style={{
        backgroundImage: `url(${Background})`,
        height: "100%",
        position: "fixed",
        width: "100%",
        backgroundSize: "cover",
      }}
    >
      <GridContainer style={{ height: "100vh" }}>
        <GridItemLogin xs={12} sm={12} md={4}></GridItemLogin>
        <GridItemLogin xs={12} sm={12} md={4}>
          <Card>
            <CardHeader color="primary">
              <h4
                className={classes.cardTitleWhite}
                style={{ textAlign: "center", fontWeight: 500, marginTop: -5 }}
              >
                HỆ THỐNG QUẢN LÝ VẬN TẢI
              </h4>
            </CardHeader>
            <LoadingOverlay
              active={isActive}
              spinner={true}
              text="Vui lòng đợi..."
            >
              <CardBody>
                <GridContainer>
                  <GridItem xs={12} sm={8} md={3}></GridItem>
                  <GridItem xs={12} sm={8} md={6}>
                    <LoginInput
                      labelText="Tài khoản"
                      id="username"
                      onChange={setuser}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={8} md={3}></GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={8} md={3}></GridItem>
                  <GridItem xs={12} sm={8} md={6}>
                    <PasswordInput
                      labelText="Mật khẩu"
                      id="password"
                      value={password}
                      onChange={setpass}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={6} sm={8} md={3}></GridItem>
                </GridContainer>
              </CardBody>
              <CardFooter>
                <Button color="info" onClick={loaddata} style={{ height: 30 }}>
                  Đăng nhập
                </Button>
                <a
                  style={{ fontWeight: 700 }}
                  target="_blank"
                  rel="noreferrer"
                  href="https://drive.google.com/drive/folders/1f6_xQly8gZD-o4VwJwsiextn-6mjyG5a"
                >
                  Hướng dẫn sử dụng
                </a>
              </CardFooter>
            </LoadingOverlay>
          </Card>
        </GridItemLogin>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="info"
            icon={AddAlert}
            message="Không được để trống tài khoản và mật khẩu"
            open={alert}
            closeNotification={() => setAlert(false)}
            close
          />
        </GridItem>
      </GridContainer>
      <GridContainer>
        <GridItem xs={12} sm={12} md={10} lg={8}>
          <Snackbar
            place="tc"
            color="warning"
            icon={AddAlert}
            message="Thông tin đăng nhập không chính xác"
            open={alert2}
            closeNotification={() => setAlert2(false)}
            close
          />
        </GridItem>
      </GridContainer>
    </div>
  );
}
